import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'font-awesome/css/font-awesome.min.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

const theme = {
 
    light: {
      primary: '#205052',
      secondary: '#203752',
      accent: '#522050',
        error: '#cb0c3f',
        info:'#355c89',
        success:'#27443E',
        warning:'#e68926',
        danger:'#ea0606'
    },
    dark: {
      primary: '#003e89',
      secondary: '#008289',
      accent: '#890082',
        error: '#cb0c3f',
        info:'#195194',
        success:'#399c14',
        warning:'#9c7714',
        danger:'#9c1439'
    },
  
}
export default new Vuetify({
    breakpoint: {
    scrollBarWidth: 16,
    thresholds: {
      xs: 600,
      sm: 960,
      md: 1280,
      lg: 1920,
    },
  },
  icons: {
    iconfont: 'mdi',
    values: {},
  },
 
  rtl: false,
  theme: {
    dark: false,
    default: 'light',
    disable: false,
    options: {
      cspNonce: undefined,
      customProperties: true,
      minifyTheme: undefined,
      themeCache: undefined,
    },
    themes: theme
  },
}

);
